import React from "react";
import "./VisionMission.scss";
import useAboutUs from "../../../hooks/useAboutUs";

import visionBg from "../../../assets/About/vision-inner-bg.png";
import visionImg from "../../../assets/About/vision-content.jpg";
import visionImg2 from "../../../assets/About/vision-content2.jpg";
import missionImg from "../../../assets/About/mission-content.jpg";
import { useState } from "react";

const VisionMission = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  const visionData = aboutUs.filter(
    (vision) => vision.DescType === "VisionMission"
  );

  let missionDesciption = "";

  if (visionData[1]?.Description) {
    missionDesciption = visionData[1]?.Description.split("<br/>");
  }

  // console.log("missionDesciption", missionDesciption, typeof missionDesciption);

  return (
    <>
      <div className="vision_mission">
        <div className="container-fluid p-0">
          <div
            className="vision_mission_bg"
            style={{ backgroundImage: `url(${visionBg})` }}
            data-aos="zoom-in"
          ></div>
          <div className="heading_box">Vision Mission</div>

          <div className="vision_mission_content">
            <div className="container">
              <div
                className="row justify-content-between"
                data-aos="zoom-in-right"
              >
                <div className="col-lg-5 my-auto">
                  <div className="vision_box">
                    <h3>{visionData[0]?.Title}</h3>
                    <p>{visionData[0]?.Description}</p>
                  </div>
                </div>

                <div className="col-lg-6 mt-4 mt-lg-0">
                  <div className="image_box">
                    <img src={visionImg} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>

              <div
                className="row justify-content-between my-5"
                data-aos="zoom-out-down"
              >
                <div className="col-lg-5 ">
                  <div className="image_box">
                    <img src={missionImg} className="img-fluid" alt="" />
                  </div>
                </div>

                <div className="col-lg-6 mt-4 mt-lg-0">
                  <div className="vision_box">
                    <h3>{visionData[1]?.Title}</h3>

                    <ul>
                      {Array(missionDesciption.length)
                        .fill(1)
                        .map((el, i) => (
                          <li key={i}>{missionDesciption[i]}</li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VisionMission;
